import {Table, TableBody, TableHeader, TableHeaderColumn, TableRow} from 'material-ui/Table';
import {UserListRow} from './';
import React, {PropTypes} from 'react';

export default function UserList({users}) {
  return (
    <Table className="user-list">
      <TableHeader>
        <TableRow>
          <TableHeaderColumn>Email</TableHeaderColumn>
          <TableHeaderColumn>Roles</TableHeaderColumn>
          <TableHeaderColumn>Last Login Date</TableHeaderColumn>
          <TableHeaderColumn>&nbsp;</TableHeaderColumn>
        </TableRow>
      </TableHeader>
      <TableBody>
        {users.valueSeq().map(user => <UserListRow key={user.get('id')} user={user} />)}
      </TableBody>
    </Table>
  );
}

UserList.propTypes = {
  users: PropTypes.object.isRequired
};



// WEBPACK FOOTER //
// ./app/features/users/components/UserList.js